<template>
  <div class="NotFound__Wrapper">
    <el-card class="card-box loginform">
      <template #header>
        <span class="clearfix">
          OPS! Página não encontrada!
        </span>
      </template>
      <div>
        <font-awesome-icon icon="user-astronaut" size="3x" />
        <font-awesome-icon icon="user-ninja" size="3x" />
        <font-awesome-icon icon="user-secret" size="3x" />
        <font-awesome-icon icon="user-tie" size="3x" />
        <font-awesome-icon icon="user-md" size="3x" />
        <font-awesome-icon icon="user-nurse" size="3x" />
        <font-awesome-icon icon="user-injured" size="3x" />
        <font-awesome-icon icon="user-graduate" size="3x" />

        <br />
        <br />
        Colocamos a nossa melhor equipe para analisar o caso.
        <br />
        <strong>
          Mas a página não foi encontrada.
        </strong>
        <br />
        Aceite nossas desculpas.
        <br />
        <br />
        <router-link to="/" v-slot="{ navigate }">
          <el-button size="default" link @click="navigate">
            <font-awesome-icon icon="home" /> Voltar ao início
          </el-button>
        </router-link>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'pinia';
import { loginStore } from '@/app/login/vuex/index';
import logo from '@/assets/logo.png';

export default {
  methods: {
    ...mapGetters(loginStore, ['currentUser']),
  },
  data() {
    return {
      /* eslint-disable global-require */
      logo,
      /* eslint-enable global-require */
    };
  },
};

</script>

<style scoped lang='less'>
  .NotFound__Wrapper {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    background: #1F2D3D;

    .card-box {
        box-shadow            : 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);
        -webkit-border-radius : 5px;
        border-radius         : 5px;
        -moz-border-radius    : 5px;
        background-clip       : padding-box;
        margin-bottom         : 20px;
        background-color      : #F9FAFC;
        border                : 2px solid #8492A6;
    }
  }
</style>
